import createVuexPersistedState from 'vuex-persistedstate'

export default function createPersistedState({ key, storage, paths, expirationTime, ...restOptions }) {
  return createVuexPersistedState({
    key,
    storage,
    paths,
    assertStorage: (storage) => storage.getState(),
    getState: async (_, storage) => {
      const persistedData = await storage.getState()
      if (!persistedData) {
        return null
      }

      const { expires, state } = persistedData
      if (expires < Date.now()) {
        await storage.removeState()

        return null
      }

      return state
    },
    setState: async (_, state, storage) => {
      const data = { state, expires: Math.round(expirationTime * 1000 + Date.now()) }
      return await storage.setState(data)
    },
    ...restOptions,
  })
}
